import React, { Fragment } from "react";
import PropTypes from "prop-types";
import ReactHtmlParser from "react-html-parser";

const Parser = ({ text, className }) => {
  if (
    text?.includes("openshift.axinocp1.central.inditex.grp") ||
    text?.includes("pre-openshift.axpreocp1.central.inditex.grp") ||
    text?.includes("sscc-pre.central.inditex.grp")
  ) {
    const regex = new RegExp(`(https?://openshift.*?)/`);
    const strRegex = regex.exec(text);
    if (strRegex && strRegex.length > 0) {
      const value = strRegex[1];
      const valueRegEx = new RegExp(value, "g");
      const suggestion = text.replace(valueRegEx, "");
      return <Fragment>{ReactHtmlParser(suggestion)}</Fragment>;
    }
  }
  return (
    <Fragment>
      <div className={`${className} fixparser`}>{ReactHtmlParser(text)}</div>
    </Fragment>
  );
};

Parser.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
};

export default Parser;
